import { Button, Divider, List } from '@mui/material';
import { useState, Fragment } from 'react';
import {
    ACCOUNT_CREATED,
    CONTACT_CREATED,
    CONTACT_NOTE_CREATED,
    QUOTE_CREATED,
    QUOTE_NOTE_CREATED,
} from '../consts';
import { Activity } from '../types';
import { ActivityLogAccountCreated } from './ActivityLogAccountCreated';
import { ActivityLogContactCreated } from './ActivityLogContactCreated';
import { ActivityLogContactNoteCreated } from './ActivityLogContactNoteCreated';
import { ActivityLogQuoteCreated } from './ActivityLogQuoteCreated';
import { ActivityLogQuoteNoteCreated } from './ActivityLogQuoteNoteCreated';

type ActivityLogIteratorProps = {
    activities: Activity[];
    pageSize: number;
};

export function ActivityLogIterator({
    activities,
    pageSize,
}: ActivityLogIteratorProps) {
    const [activitiesDisplayed, setActivityDisplayed] = useState(pageSize);

    const filteredActivities = activities.slice(0, activitiesDisplayed);

    return (
        <List
            sx={{
                '& .MuiListItem-root': {
                    marginTop: 0,
                    marginBottom: 1,
                },
                '& .MuiListItem-root:not(:first-of-type)': {
                    marginTop: 1,
                },
            }}
        >
            {filteredActivities.map((activity, index) => (
                <Fragment key={index}>
                    <ActivityItem key={activity.id} activity={activity} />
                    <Divider />
                </Fragment>
            ))}

            {activitiesDisplayed < activities.length && (
                <Button
                    onClick={() =>
                        setActivityDisplayed(
                            activitiesDisplayed =>
                                activitiesDisplayed + pageSize
                        )
                    }
                    fullWidth
                >
                    Load more activity
                </Button>
            )}
        </List>
    );
}

function ActivityItem({ activity }: { activity: Activity }) {
    if (activity.type === ACCOUNT_CREATED) {
        return <ActivityLogAccountCreated activity={activity} />;
    }

    if (activity.type === CONTACT_CREATED) {
        return <ActivityLogContactCreated activity={activity} />;
    }

    if (activity.type === CONTACT_NOTE_CREATED) {
        return <ActivityLogContactNoteCreated activity={activity} />;
    }

    if (activity.type === QUOTE_CREATED) {
        return <ActivityLogQuoteCreated activity={activity} />;
    }

    if (activity.type === QUOTE_NOTE_CREATED) {
        return <ActivityLogQuoteNoteCreated activity={activity} />;
    }

    return null;
}
